/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-04-16 14:39:05
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-28 15:26:58
 * @FilePath: \duilv_mobile\src\filters\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const statusType = [
	{ type: 1, name: "供材项目" },
	{ type: 2, name: "施工项目" },
	{ type: 3, name: "其他" },
  ];
  const status = [
	{ type: 0, name: "待修改" },
	{ type: 1, name: "待部门经理审核" },
	{ type: 2, name: "待中心领导审核" },
	{ type: 3, name: "待HRBP审核" },
	{ type: 4, name: "待申请人签收" },
	{ type: 5, name: "流程结束" },
  ];
  const UserType=[
	{ type: 1, name: "申请人" },
	{ type: 2, name: "部门经理" },
	{ type: 3, name: "中心领导" },
	{ type: 4, name: "HRBP" },
  ]
  const peoType=[
	{ type: 1, name: "通过" },
	{ type: 2, name: "驳回" },
  ]
  const statusTypeFilter = type => {
	const sexTy = statusType.find(obj => obj.type === type);
	return sexTy ? sexTy.name : null;
  };
  const statusFilter = type => {
	const sexTy = status.find(obj => obj.type === type);
	return sexTy ? sexTy.name : null;
  };
  const userFilter = type => {
	const sexTy = UserType.find(obj => obj.type === type);
	return sexTy ? sexTy.name : null;
  };
  const peType = type => {
	const sexTy = peoType.find(obj => obj.type === type);
	return sexTy ? sexTy.name : null;
  };
  const formatnum = num => {//金额显示
	var result = "",
	  counter = 0;
	num = Number(num || 0).toString();
	for (var i = num.length - 1; i >= 0; i--) {
	  counter++;
	  result = num.charAt(i) + result;
	  if (!(counter % 3) && i != 0) {
		result = "," + result;
	  }
	}
	return result;
  };
  const ellipsis=value=> {
	if (!value) return "";
	if (value.length > 9) {
	  return value.slice(0, 9) + "...";
	}
	return value;
  }
  const ellipsiss=value=> {
	if (!value) return "";
	if (value.length > 15) {
	  return value.slice(0, 15) + "...";
	}
	return value;
  }
  export default {
	statusTypeFilter,
	statusFilter,
	formatnum,
	userFilter,
	peType,
	ellipsis,
	ellipsiss
  };
  